import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderEaster from "../../../../src/content/easter/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderEaster,
  React
};